import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import logo from '../assets/eurocas-logo.jpeg';

const navLinkClassName = ({ isActive }) => (isActive ? 'nav-link active' : 'nav-link');

const Navbar = () => {
  const { currentUser, logout } = useApp();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Close the mobile dropdown on every navigation — otherwise it stays
  // open covering the page after tapping a link.
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  if (!currentUser) return null;

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="EUROCAS Career & Schooling Madurai" className="navbar-logo" />
          <span className="navbar-product-tag" title="Language Management System">LMS</span>
        </Link>
        <button
          type="button"
          className="navbar-toggle"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span className="navbar-toggle-bar" />
          <span className="navbar-toggle-bar" />
          <span className="navbar-toggle-bar" />
        </button>
        <div className={`navbar-links${menuOpen ? ' is-open' : ''}`}>
          {currentUser.role === 'admin' && (
            <NavLink to="/" end className={navLinkClassName} onClick={closeMenu}>Overview</NavLink>
          )}
          {currentUser.role === 'admin' && (
            <NavLink to="/staff" className={navLinkClassName} onClick={closeMenu}>Staff</NavLink>
          )}
          {(currentUser.role === 'teacher' || currentUser.role === 'admin') && (
            <NavLink to="/batches" className={navLinkClassName} onClick={closeMenu}>Batches</NavLink>
          )}
          {currentUser.role === 'admin' && (
            <NavLink to="/students" className={navLinkClassName} onClick={closeMenu}>Students</NavLink>
          )}
          {currentUser.role === 'teacher' && (
            <NavLink to="/attendance" className={navLinkClassName} onClick={closeMenu}>Attendance</NavLink>
          )}
          {currentUser.role === 'student' && (
            <NavLink to="/attendance" className={navLinkClassName} onClick={closeMenu}>My Attendance</NavLink>
          )}
          <NavLink to="/materials" className={navLinkClassName} onClick={closeMenu}>Materials</NavLink>
          <NavLink to="/exams" className={navLinkClassName} onClick={closeMenu}>Exams</NavLink>
          {currentUser.role === 'admin' && (
            <NavLink to="/backup" className={navLinkClassName} onClick={closeMenu}>Backup</NavLink>
          )}
        </div>
      </div>
      <div className={`navbar-actions${menuOpen ? ' is-open' : ''}`}>
        <span className="navbar-user">{currentUser.name}</span>
        <button className="btn-link" onClick={logout}>Log out</button>
      </div>
    </nav>
  );
};

export default Navbar;
